import { CARD_H, CARD_W } from '../geometry';
import { isNoteNode, getNoteLayoutDims } from '../../FlowchartView/utils/noteUtils';
import { isMilestoneNode, getMilestoneLayoutDims } from '../../FlowchartView/utils/milestoneUtils';

export function sizeOf(task, boxes) {
  const box = boxes[task?.id];
  if (box?.w > 0 && box?.h > 0) return { width: box.w, height: box.h };
  if (isNoteNode(task)) return getNoteLayoutDims(null, task.id);
  if (isMilestoneNode(task)) return getMilestoneLayoutDims(null, task.id);
  return { width: task?.width || CARD_W, height: task?.height || CARD_H };
}
